var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1177_32507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.13728 11.2781L2.41853 13.7188L2.03103 15.0375C1.95291 15.3032 2.02478 15.5875 2.21853 15.7813C2.41228 15.975 2.69666 16.0469 2.95916 15.9719L4.28103 15.5813L6.72166 14.8625C7.10916 14.75 7.46228 14.5532 7.76541 14.2875C7.80916 14.25 7.84978 14.2094 7.89041 14.1688L17.3967 4.66565C18.081 3.98127 18.1654 2.92815 17.6529 2.15002C17.581 2.04065 17.4935 1.9344 17.3967 1.83752L16.1654 0.603149C15.3842 -0.178101 14.1185 -0.178101 13.3373 0.603149L3.83103 10.1094C3.50603 10.4344 3.26853 10.8375 3.13728 11.2781ZM4.57478 11.7C4.62791 11.525 4.71541 11.3625 4.83728 11.225C4.85603 11.2063 4.87166 11.1875 4.89041 11.1688L12.031 4.03127L13.9685 5.96877L6.83103 13.1094C6.68416 13.2563 6.49978 13.3657 6.29978 13.425L5.56853 13.6406L3.85603 14.1438L4.35916 12.4313L4.57478 11.7Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1177_32507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.f230dcef641f90aa33df440e0c1d15f2.svg";
export { ForwardRef as ReactComponent };